import PropTypes from 'prop-types';
import React from 'react';

const List = ({ variant = 'vertical', children, className = '', ...props }) => {
	const variants = {
		horizontal: 'list-horizontal',
		slider: 'list-horizontal d-flex w-100',
		vertical: '',
	};

	return (
		<>
			<nav>
				<ul className={`${variants[variant]} ${className}`} {...props}>
					{children}
				</ul>
			</nav>
		</>
	);
};

List.propTypes = {
	variant: PropTypes.string,
	children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
	className: PropTypes.string,
};

export default List;
